import createCache from '@emotion/cache';

/**
 * Creates Emotion cache with CSP nonce for Material-UI
 * The nonce is injected by the server-side ContentSecurityPolicyMiddleware
 */
export function createEmotionCache() {
  // Get nonce from window (injected by server in index.html)
  const nonce = (window as any).CSP_NONCE;

  return createCache({
    key: 'mui',
    nonce: nonce,
    prepend: true,
  });
}
